import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
// eslint-disable-next-line jira/import-whitelist
import fetchIsGlobalScopeEnrolmentEnabledFromServer from '@atlassian/jira-issue-navigator-global-scope-enrolment/src/services/global-scope-enrolment/fetch-is-global-scope-enrolment-enabled-from-server/index.tsx';
import type { RouterDataContext, ResourceStoreContext } from '@atlassian/react-resource-router';

export const GLOBAL_SCOPE_ROUTES: readonly string[] = [
	'global-issue-navigator',
	'global-issue-navigator-browse-issue-redirect',
];

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async (routerContext: RouterDataContext, customContext: ResourceStoreContext) => {
	// If we're rendering Global Scope in SSR then we can assume the user is enrolled, as the monolith has decided to
	// send the request to Jira Frontend
	const isGlobalScopeRoute = GLOBAL_SCOPE_ROUTES.includes(routerContext.route.name);
	if (__SERVER__ && isGlobalScopeRoute) {
		return true;
	}

	try {
		return await fetchIsGlobalScopeEnrolmentEnabledFromServer(customContext.tenantContext.cloudId);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		await fireErrorAnalytics({
			meta: {
				id: 'jiraNinGlobalScopeEnrolmentEnabledResource',
				packageName: 'jiraRouterResourcesIsNinGlobalScopeEnrolmentEnabled',

				teamName: 'empanada',
			},
			error,
			sendToPrivacyUnsafeSplunk: true,
		});
		return false;
	}
};
